import { EntityState, EntityStore, StoreConfig } from "@datorama/akita";
import { singleton } from "tsyringe";

import ProductReviewInfoEntity from "../entities/ProductReviewInfoEntity";

export type ListingProductInfoState = EntityState<
    ProductReviewInfoEntity,
    number
>;

@singleton()
@StoreConfig({ name: "ListingProductInfoStore", idKey: "productId" })
class ListingProductInfoStore extends EntityStore<ListingProductInfoState> {
    constructor() {
        super();
    }
}

export default ListingProductInfoStore;
